// Add custom components as sub-modules to PESAPP
// PESAPP.extend(PESAPP.myExample).init();

PESAPP.myExample = (function(m, $) {

  // Specify some default options
  m.options = {
    template: 'my-example'
  };

  // Add an init method
  m.init = function() {
    var parent = this;
    var views = $(parent.view);
    // Add dependencies
    parent = PESAPP.extend(PESAPP.htmlModel, parent);
    parent = PESAPP.extend(PESAPP.template, parent);

    views.each(function() {
      var view = $(this);
      var self = PESAPP.extend(parent, { view: view });

      // Methods
      self.compileModel();
      self.getTemplate();
      self.updateTemplate();

      return self;
    });
  };

  // Return sub-module
  return m;

}(PESAPP.myExample || {}, jQuery));
